import ExaminationQuestionGroup, { Variant } from './ExaminationQuestionGroup';

export { Variant };
export default ExaminationQuestionGroup;
